export var mixin = {
  methods: {
    checkEmail(email) {
      let dator = new this.$Dator.Dator();
      let paterns = [
        { strategy: "isEmpty", 
        // errMsg: "請輸入電郵" 
        errMsg:this.language('forgetPassword.placeholder2')
      }
      ];
      paterns.push({ 
        strategy: "checkEmail",
      //  errMsg: "請輸入正確的電郵地址" 
       errMsg:this.language('ui.placeholderEmail3')
      });
      dator.add(email, paterns);
      if (dator.getErrmsg()) {
        return dator.getErrmsg();
      } else {
        return "";
      }
    },
  },
};
